import React from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import Breadcrumbs from '../breadcrumbs';
import {Wrapper} from '../wrapper';
import {AboutContent} from './components';

const About = () => (
  <div>
    <Breadcrumbs>
      <li><Link to="/">Головна</Link></li>
      <li><Link to="/about">Про портал</Link></li>
    </Breadcrumbs>
    <Wrapper>
      <Grid>
        <h2>Про портал</h2>
        <AboutContent>
          <p>Єдиний медичний портал Одеси — це онлайн-ресурс, що містить інформацію про всі медичні заклади міста. Ви можете знайти час роботи будь-якого лікаря чи надання тієї чи
             іншої медичної послуги та обрати найбільш зручний для себе медичний заклад за потрібним профілем. Найближчим часом буде надана можливість онлайн-запису на прийом до лікаря.</p>

          <p>Портал містить інформацію про роботу міського департаменту охорони здоров'я та надає можливість залишити електронне звернення із зауваженнями, побажаннями чи словами вдячності медпрацівникам в режимі онлайн.
             Також Ви можете залишити питання на медичну тематику та отримати відповідь від провідних фахівців Одеси.</p>

          <p>На порталі розміщені найбільш актуальні новини в медичній сфері Одеси та України, роз'яснення з питань медичної реформи, сучасна інформація про профілактику та лікування різноманітних захворювань,
             контакти неурядових та громадських організацій, що працюють в сфері охорони здоров'я.</p>
        </AboutContent>
      </Grid>
    </Wrapper>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/system/about/index.js